import React, { FC, ComponentProps } from "react";
import { cls } from "cls";

const Header: FC<ComponentProps<"h3">> = ({ className, children, ...rest }) => (
  <h3 className={cls("mb-0", className)} {...rest}>
    {children}
  </h3>
);

export default Header;
